import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Time from 'react-time';
// import styled from 'styled-components';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
// import { lighten } from 'polished';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import { getFieldValue } from '../../helpers';
// import StatusIcon from './StatusIcon';

// const TableRow = styled(MuiTableRow)`
//   &.Mui-selected, &.Mui-selected:hover {
//     ${'' /* background-color: ${props => lighten(0.40, props.theme.palette.primary.main)}; */}
//     background-color: ${props => props.theme.palette.action.selected};
//   };
//   ${'' /* cursor: pointer */}
// `;

// const Container = styled.div`
//   display: flex;
//   align-items: center;

//   svg {
//     margin-right: ${props => props.theme.spacing(2)}px;
//   }
// `;

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});

function CTableRow (props) {
  const { noOfNonSelectableRows = 0, isExpandable, isExpanded, rowData, colDef, onRowSelect, onExpandedRow, onExpand } = props;
  const classes = useRowStyles();
  const isDisabled = noOfNonSelectableRows && rowData.default;
  let totalColumn = colDef.length;

  if (onRowSelect) {
    totalColumn += 1;
  }

  if (isExpandable) {
    totalColumn += 1;
  }

  function tableRowClicked () {
    if (isExpandable) {
      if (isExpanded) {
        onExpandedRow(-1);
      }
      else {
        onExpandedRow(rowData);
      }
    }
  }

  function cellValue (col) {
    if (col.isDate) {
      return (
        <Time value={getFieldValue(col, rowData)} format="YYYY-MM-DD HH:mm" />
      );
    } else if (col.vpnIcon) {
      // Need to change this to specific implemenation to common.
      return (
        <IconButton onClick={() => props.onPublicKeyInfo(rowData)}>
          <VpnKeyIcon />
        </IconButton>
      )
    } else {
      return (
        <>
          {/* {col.fieldIcon ? <StatusIcon status={rowData[col.fieldIcon]} /> : null} */}
          {getFieldValue(col, rowData) || col.defaultValue || '-'}
        </>
      )
    }
  }

  return (
    <>
      <TableRow hover className={classes.root} style={{ cursor: 'pointer' }} onClick={tableRowClicked}>
        {
          onRowSelect
            ? (
              <TableCell padding='none'>
                <Checkbox checked={props.isSelected} onChange={e => props.onRowSelect(e.target.checked, props.rowData)} disabled={isDisabled}
                  onClick={ e => e.stopPropagation() }/>
              </TableCell>
            )
            : null
        }
        {
          colDef
            .filter(col => !col.hidden)
            .map((col, idx) => {
              return (
                <TableCell key={idx} style={{ width: col.rowWidth || '', paddingTop: onRowSelect ? '' : 8, paddingBottom: onRowSelect? '' : 8 }}>
                  <div>
                    {cellValue(col)}
                  </div>
                </TableCell>
              );
            })
        }
        {
          isExpandable
            ? (
              <TableCell onClick={tableRowClicked}>
                <IconButton size='small'>
                  { isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon /> }
                </IconButton>
              </TableCell>
            )
            : null
        }
      </TableRow>
      {
        isExpandable
          ? (
            <TableRow>
              <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={totalColumn}>
                <Collapse in={isExpanded} timeout='auto' unmountOnExit>
                  <Box margin={1}>
                    {onExpand(rowData)}
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          )
          : null
      }
    </>
  );
}

CTableRow.propTypes = {
  idx: PropTypes.number.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isExpandable: PropTypes.bool.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onRowSelect: PropTypes.func,
  onRowClicked: PropTypes.func,
  onExpandedRow: PropTypes.func,
  onExpand: PropTypes.func,
  colDef: PropTypes.arrayOf(PropTypes.object),
  rowData: PropTypes.object.isRequired,
  onPublicKeyInfo: PropTypes.func
};

export default memo(CTableRow);
